export default __webpack_public_path__ + "static/media/cmsocupacional.43463800.jpg";